import * as tslib_1 from "tslib";
import { isFunction } from "../../helpers";
import { BaseBlock } from "../BaseBlock";
/**
 * AsyncBlockInit provides dummy block instance that can handle asyncronous loading of
 * JavaScript artifacts and init any Responsive or React block before its source was
 * downloaded on the page.
 */
var AsyncBlockInit = /** @class */ (function (_super) {
    tslib_1.__extends(AsyncBlockInit, _super);
    /**
     * Constructor
     * @param {SBMsgBus} bus used for messages exchange
     * @param {String} blockClassName Unique name of the block constructor function or class
     * @param {String} domId unique ID used for identifying correct DOM element and message bus topic for the instance
     * @param {Any} rest Any other parametters passed to the constructor are stored and passed on during init
     */
    function AsyncBlockInit(bus, blockClassName, domId) {
        var rest = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            rest[_i - 3] = arguments[_i];
        }
        var _this = _super.apply(this, tslib_1.__spread([domId], rest)) || this;
        _this.block;
        _this.bus = bus;
        _this.rest = rest;
        _this.panelId = "";
        _this.domId = domId;
        _this.isLoaded = false;
        _this.class = blockClassName;
        _this.paramsToSet = undefined;
        _this.uniqueTopic = "" + _this.bus.sbPrefix + domId;
        _this.classTopic = "" + _this.bus.sbPrefix + blockClassName + "_loaded";
        _this.instanceTopic = _this.uniqueTopic + "_loaded";
        _this.loaded = _this.loaded.bind(_this);
        _this.busMsgRouter = _this.busMsgRouter.bind(_this);
        _this.bus.subscribe("" + _this.classTopic, _this.loaded);
        return _this;
    }
    /**
     * membersRemap, execute once method that links between members of the real block and dummy block
     */
    AsyncBlockInit.prototype.membersRemap = function () {
        var _this = this;
        // defensive coding for smartasses
        if (this.isLoaded) {
            // compatibility with mobile app
            var specialProps_1 = { PanelID: "panelId", parentBlock: "parentBlock" };
            Object.keys(specialProps_1).forEach(function (x) { return Object.defineProperty(_this.block, x, {
                get: function () { return _this[specialProps_1[x]]; },
                set: function (y) { return _this[specialProps_1[x]] = y; }
            }); });
            var _loop_1 = function (m) {
                if (typeof this_1.block[m] === "function" &&
                    m !== "setParams" &&
                    m !== "destroy") {
                    this_1[m] = this_1.block[m];
                }
                else {
                    Object.defineProperty(this_1, m, {
                        get: function () {
                            return _this.block[m];
                        },
                        set: function (x) { return _this.block[m] = x; }
                    });
                }
            };
            var this_1 = this;
            for (var m in this.block) {
                _loop_1(m);
            }
            // You better lose yourself in the music, the moment
            // You own it, you better never let it go
            // You only get one shot, do not miss your chance to blow
            // This opportunity comes once in a lifetime
            this.membersRemap = function () { return undefined; };
        }
        return undefined;
    };
    /**
     * loaded, execute once method that creates instance of the real block after its code was downloaded on the page
     * @param {Boolean} x received as message from the block that loaded
     */
    AsyncBlockInit.prototype.loaded = function (x) {
        var _this = this;
        var _a, _b;
        if (x === true && typeof window[this.class] === "function") {
            this.isLoaded = x;
            this.block = new ((_a = window[this.class]).bind.apply(_a, tslib_1.__spread([void 0, this.domId], this.rest)))();
            this.bus.unsubscribe("" + this.classTopic, this.loaded);
            this.bus.subscribe("" + this.uniqueTopic, this.busMsgRouter);
            this.membersRemap();
            this.bus.post((_b = {}, _b["" + this.instanceTopic] = true, _b));
            this.loaded = function () { return _this; };
        }
        return this;
    };
    /**
     * busMsgRouter, routes any async messages sent to the block togher with any data sent
     * @param {Any} x parametters for the method called via sbMsgBus.post(...)
     */
    AsyncBlockInit.prototype.busMsgRouter = function (x) {
        var _this = this;
        x && Object.keys(x).forEach(function (y) {
            if (_this.isLoaded && isFunction(_this.block[y])) {
                try {
                    _this.block[y](x[y]);
                }
                catch (e) {
                    console.error(e);
                }
            }
        });
    };
    /**
     * destroy, calls super.destroy(), then unsubscribes from the bus leaving the block dead
     */
    AsyncBlockInit.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.bus.unsubscribe("" + this.uniqueTopic, this.busMsgRouter);
        return this;
    };
    /**
     * setParams, proxy of block.setParams, that works in async way. Stores params in order to pass them
     * to the block once it is downloaded and its instance is created
     * @param {Any} x params to proxy
     */
    AsyncBlockInit.prototype.setParams = function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
        }
        var _a;
        if (this.isLoaded) {
            return (_a = this.block).setParams.apply(_a, tslib_1.__spread(x));
        }
        else {
            this.paramsToSet = x;
        }
        return this;
    };
    /**
     * activate, async version of the activate method available to the application before the
     * real block is downloaded and init. If called directly it is going to post message to
     * to its own topic.
     * @param {Any} x params to proxy
     */
    AsyncBlockInit.prototype.activate = function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
        }
        var _a, _b, _c;
        if (this.isLoaded) {
            if (this.paramsToSet) {
                (_a = this.block).setParams.apply(_a, tslib_1.__spread(this.paramsToSet));
                this.paramsToSet = undefined;
            }
            return (_b = this.block).activate.apply(_b, tslib_1.__spread(x));
        }
        else {
            this.bus.post((_c = {},
                _c[this.uniqueTopic] = {
                    activate: x
                },
                _c));
        }
        return this;
    };
    return AsyncBlockInit;
}(BaseBlock));
export { AsyncBlockInit };
//# sourceMappingURL=AsyncBlockInit.js.map